module.exports = __webpack_public_path__ + "static/img/li8_5.31ef10a6.png";